import { ATOM_KEY } from "@/shared/client/keys";
import { atom, useRecoilValue, useSetRecoilState } from "recoil";
import { type SelectedPerson } from "../types";

const selectedPersonAtom = atom<SelectedPerson>({
    default: { adult: 0, child: 0, infant: 0 },
    key: ATOM_KEY.SELECTED_ADULT_PERSON,
});

export const useSetSelectedPerson = () => useSetRecoilState(selectedPersonAtom);
export const useSelectedPersonValue = () => useRecoilValue(selectedPersonAtom);
